import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../store/store'
import { withdrawTimeOffRequest } from '../store/slices/Requestor/createNewRequestSlice'
import { getBalance } from '../store/slices/Requestor/employeeInfoSlice'
import { trackFormSubmit, trackFormError } from '../services/analytics'

export default function useWithdrawRequest() {
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const withdraw = useCallback(async (requestId: string, empNuid: string) => {
    setError(null)
    setLoading(true)
    try {
      await dispatch(withdrawTimeOffRequest({ requestId, empNuid })).unwrap()
      trackFormSubmit('withdraw-request', { requestId })
      // Re-fetch the time off balance so it reflects the withdrawn request
      // everywhere it's displayed (TimeOffBalance, etc.).
      dispatch(getBalance())
      return true
    } catch (err: any) {
      trackFormError(['withdraw-failed'], 'withdraw-request')
      setError(err?.message || String(err) || 'Failed to withdraw request')
      return false
    } finally {
      setLoading(false)
    }
  }, [dispatch])

  const clearError = useCallback(() => setError(null), [])

  return { withdraw, loading, error, clearError }
}
